module.exports = __webpack_public_path__ + "media/images/favicon/apple-icon-57x57-d5159fe8a54d4557440d88e1fca87951.png";